import qs from 'query-string';

function beautifyUrl(
  path: string,
  config: { params: Record<string, string>; query: Record<string, string> } = {
    params: {},
    query: {},
  },
) {
  let tempUrl = path;

  if (config.params) {
    Object.keys(config.params).forEach((param) => {
      tempUrl = tempUrl.replace(`:${param}`, config.params[param]);
    });
  }

  if (config.query) {
    tempUrl += `?${qs.stringify(config.query, { arrayFormat: 'comma' })}`;
  }

  return tempUrl;
}

export default beautifyUrl;
